import { FC } from "react";
// 方法
import getFormItem from '../../hook/getFormItem';
import { formatFormItemName } from "../../util";
// 常量
import { MainTableCellProps } from "../../interface";

/** 主表单元格 */
const MainTableCell: FC<MainTableCellProps> = props => {
  const { editable, form, record, rowIndex, name = '', formItemType, simpleFormItemProps, ...restProps } = props;

  return editable ? (
    <td {...restProps}>
      {getFormItem(record, { ...simpleFormItemProps, formItemType, rowIndex, form, name: formatFormItemName(name, record.key), })}
    </td>
  ) : (
    <div {...restProps} />
  );
};

export default MainTableCell;
